import React from "react";
import { Trans } from 'components';

import i52 from "assets/images/i52.png";

const NoResultsPanel = () => (
  <div className="noresults">
    <div className="noresults-icon">
      <img src={i52} alt="" />
    </div>
    <div className="noresults-message">
      <h3><Trans>Brak wyników</Trans></h3>
      <div>
      <Trans>Niestety nie udało się znaleźć szukanej frazy.</Trans> <br /> <Trans>Spróbuj ponownie.</Trans>
      </div>
    </div>
  </div>
);

export default NoResultsPanel;


// WEBPACK FOOTER //
// ./src/partialComponents/NoResultsPanel.jsx